import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "../../Modules/Components/Navigation";
import BackBtnLeft from "../../icons/BackBtnLeft";
import { USER_CURRENT_PATH } from "../../helpers/common";

const PublicValidator = () => {
  const location = useLocation();
  const cleanedPath = location.pathname.replace(/^\/|\/$/g, "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <div className={`app_bg ${cleanedPath}`}>
        <div className="container">
          <Navigation />
          {(window.location.pathname !== USER_CURRENT_PATH.HOME) && <BackBtnLeft />}
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default PublicValidator;
